'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cookieModal = require('../actions/cookie-modal');

var COOKIE_STATUS_VARIABLE = 'COOKIE_STATUS';

var INITIAL_STATE = {
    isOpen: true
};

var localStorage = void 0;
if (typeof window != "undefined") {
    localStorage = window.localStorage;
}

function setCookieStateVariable(state) {
    if (localStorage) {
        localStorage.setItem(COOKIE_STATUS_VARIABLE, JSON.stringify(state));
    }
    return state;
}

function getCookieStateVariable() {
    if (localStorage) {
        return JSON.parse(localStorage.getItem(COOKIE_STATUS_VARIABLE)) || INITIAL_STATE;
    }
    return {};
}

var cookieModal = function cookieModal(state, action) {
    switch (action.type) {
        case _cookieModal.CLOSE_COOKIE_MODAL:
            return setCookieStateVariable(Object.assign({}, state, { isOpen: false }));
        case _cookieModal.READ_BUTTON_CLICKED:
            return setCookieStateVariable(Object.assign({}, state, { isOpen: false }));
        default:
            return getCookieStateVariable();
    }
};

exports.default = cookieModal;